import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.adminConfigSchoolStagesPage.setFetching(isFetching)

const fetchSchoolStages = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.get(prefix.schoolStages)
    .then(({ data }) => data)
    .then((schoolStages) => {
      reducers.marketplace.adminConfigSchoolStagesPage.setSchoolStages(schoolStages)
    })
    .catch((error) => {
      console.log(error)
    })
}

const setSchoolStages = (schoolStages) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.schoolStages, schoolStages)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}


export default {
  setFetching,
  fetchSchoolStages,
  setSchoolStages,
}
